<template>
  <div>
    <h1 class="modal-h1 mb-3">
      <button type="button"
              class="btn btn-back"
              @click="$emit('cancel')"
      />
      <span v-if="typeId === 1">
        Send a customer email
      </span>
      <span v-if="typeId === 2">
        {{ job.ref_id }} - Send an acknowledgement email
      </span>
      <span v-if="typeId === 3">
        Send a settlement email
      </span>
    </h1>
    <div class="l-bg-white" v-if="variablesLoaded && templateLoaded">
      <div class="row mb-1">
        <div class="col pl-3 pr-1">
          <div class="select-wrap">
            <label>Email</label>
            <simple-select v-model="customer_email_selected"
                           :options="customerContactsWithEmail"
                           label="email"
                           return-value="email"
                           placeholder="Select recipient"
            />
          </div>
          <error-field :errors="errors" field="to" />
        </div>
        <div class="col pl-1" />
      </div>
      <div class="row mb-2">
        <div class="col-6 pr-1">
          <div class="select-wrap">
            <label>Subject</label>
            <input v-model="claimEmail.subject" type="text" class="form-control" ref="subject"
                   @click="addingVariableOn = 'subject'"
            />
          </div>
          <error-field :errors="errors" field="subject" />
        </div>
        <div class="col-6 pl-1">
          <div class="select-wrap">
            <label>Choose from template</label>
            <simple-select v-model="claimEmail.template"
                           :options="claimEmail.emailTemplates"
                           placeholder="Select template"
                           @input="loadEmailTemplate"
            />
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col">
          <div class="select-wrap h-auto">
            <label>Email body</label>
            <textarea ref="ta" name="" id="" cols="30" rows="10" class="select-wrap-textarea form-control"
                      v-model="claimEmail.body"
                      @click="addingVariableOn = 'ta'"
            />
          </div>
          <error-field :errors="errors" field="body" />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col">
          <div>
            <span class="badge badge-primary mx-1 unselectable pointer"
                  v-for="(variable, key, index) in claimEmail.variables"
                  :key="index" @click="insertVariable(variable)"
            >{{ key }}</span>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-right">
          <button type="button" class="btn btn-secondary" @click="closeModal()">
            Discard
          </button>
          <button class="btn btn-primary ld-ext-right"
                  type="button"
                  :class="loadingButton ? 'running' : ''"
                  :disabled="buttonDisabled"
                  @click="sendEmail"
          >
            Send Email
            <div class="ld ld-ball ld-flip" />
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <error-field :errors="errors" field="settlement" />
        </div>
      </div>
    </div>
    <template v-else>
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Errors from '../../../classes/Errors';
import ErrorField from '../../ErrorField';

export default {
  components: {
    ErrorField,
  },
  props: {
    job: {
      type: Object,
      default: () => {},
    },
    typeId: {
      type: Number,
      default: () => null,
    },
    list: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    buttonDisabled: false,
    loadingButton: false,
    errors: new Errors(),
    customer_email_selected: '',
    customerContactsWithEmail: null,
    addingVariableOn: 'subject',
    variablesLoaded: false,
    templateLoaded: false,
    claimEmail: {
      from: '',
      to: '',
      body: '',
      subject: '',
      template: '',
      emailTemplates: [],
      type_id: 0,
      notes: '',
      variables: [],
    },
  }),
  created() {
    this.customer_email_selected = this.job.customer.email;
    this.customerContactsWithEmail = this.job.customer.contacts.filter(
      el => el.email !== undefined,
    );
    if (!this.customerContactsWithEmail.find(el => el.email === this.job.customer.email)) {
      this.customerContactsWithEmail.push({
        customer_id: this.job.customer.id,
        email: this.job.customer.email,
        id: '',
        phone: '',
      });
    }
    this.getEmailTemplates();
    this.loadVariables();
  },
  methods: {
    getEmailTemplates() {
      axios
        .get(`/claims/templates?type_id=${this.typeId}`)
        .then(res => {
          this.claimEmail.emailTemplates = res.data.data;
          this.templateLoaded = true;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    sendEmail() {
      this.loadingButton = true;
      this.buttonDisabled = true;
      axios
        .post(`/claims/${this.$route.params.id}/emails`, {
          from: this.job.company.email,
          to: this.customer_email_selected,
          subject: this.claimEmail.subject,
          body: this.claimEmail.body,
          type_id: this.typeId,
        })
        .then(() => {
          toastr.success('Successfully sent email');
          this.$emit('update');
          this.$emit('cancel');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    loadEmailTemplate() {
      this.claimEmail.body = this.swapVariables(
        this.claimEmail.emailTemplates.find(temp => temp.id === this.claimEmail.template).body,
      );
      this.claimEmail.subject = this.swapVariables(
        this.claimEmail.emailTemplates.find(temp => temp.id === this.claimEmail.template).subject,
      );
    },
    loadVariables() {
      if (this.list) {
        axios
          .get(`/claims/${this.job.id}/templates/values`)
          .then(res => {
            this.claimEmail.variables = res.data;
            this.variablesLoaded = true;
          })
          .catch(err => this.errors.record(err.response.data.error));
      } else {
        axios
          .get(`/claims/${this.$route.params.id}/templates/values`)
          .then(res => {
            this.claimEmail.variables = res.data;
            this.variablesLoaded = true;
          })
          .catch(err => this.errors.record(err.response.data.error));
      }
    },
    insertVariable(variable) {
      const textarea = this.addingVariableOn === 'subject' ? this.$refs.subject : this.$refs.ta;
      const cursorPosition = textarea.selectionStart;
      const textBefore = textarea.value.substring(0, cursorPosition);
      const textAfter = textarea.value.substring(cursorPosition, textarea.value.length);
      textarea.value = textBefore + variable + textAfter;
      if (this.addingVariableOn === 'subject') {
        this.claimEmail.subject = textarea.value;
      } else {
        this.claimEmail.body = textarea.value;
      }
      if (textarea.setSelectionRange) {
        textarea.focus();
        textarea.setSelectionRange(
          cursorPosition + variable.length,
          cursorPosition + variable.length,
        );
      }
    },
    swapVariables(text) {
      return text.replace(/\{\{(.*?)\}\}/g, (match, string) => this.claimEmail.variables[string]);
    },
    closeModal() {
      this.$emit('cancel');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/claims/Modals/SendClaimEmail.vue